export const isSuccessResponse = ({ status }: { status: number }) =>
  status >= 200 && status < 300
